import React from 'react';

const FourZeroFour = () => {
    return (
        <div>
            <h1>Este es un error 404</h1>
        </div>
    );
};

export default FourZeroFour;